import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import './circular-loader.scss';

interface IProps extends CircularProgressProps {
  flexGrow?: number;
  padding?: number;
  paddingTop?: number;
}

export const CircularLoader = ({
  flexGrow = 1,
  padding = 0,
  paddingTop = 0,
  ...props
}: IProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow,
        padding,
        paddingTop,
      }}
      data-testid="box"
    >
      <CircularProgress data-testid="circular-progress" {...props} />
    </Box>
  );
};
